// 3rd-party THD Libraries
const DigitalData = require('digitalData');

// 3rd-party Vendor Libraries
const GestureHandler = require('global.gestureHandler');

const StoreFinderCore = require('header.storeFinder.core');

// ES6 Modules
const Utility = require('header.utility');
const Analytics = require('header.analytics');
const FlyoutDataService = require('header.data');
const Logo = require('header.logo');
const MainFlyout = require('header.mainFlyout');
const MyAccount = require('header.myAccount');
const Perks = require('header.perks');
const MyCart = require('header.myCart');
const Search = require('header.search');
const TaskLinks = require('header.taskLinks');
const ToolTips = require('header.toolTips');
const DropDown = require('header.dropdown');
const SmartBanner = require('footer.smartBanner');
const footerPcLink = require('footer.pcLink');
const Mask = require('header.mask');
const SimpleFlyout = require('header.simpleFlyout');
const NavigationLinks = require('header.navigationLinks');
const footerCopyrightText = require('footer.copyrightText');

const {
  dynamicPhoneNumberElements,
  dynamicShortCodeElements,
  renderPhoneNumbers,
} = require('shared.phoneNumber');

if (process.env.NODE_ENV === 'development') {
  const { initializeMockServer } = require('mocks.setup');
  initializeMockServer();
}

Utility.setChannelId('web');
DigitalData.init();
GestureHandler.init();
Analytics.init();
DropDown.init();
FlyoutDataService.init();
Logo.init();
MainFlyout.init();
MyAccount.init();
Perks.init();
MyCart.init();
SimpleFlyout.init();
Search.init();
StoreFinderCore.init();
TaskLinks.init();
ToolTips.init();
SmartBanner.init();
footerPcLink.init();
Mask.init();
NavigationLinks.init();
renderPhoneNumbers(dynamicPhoneNumberElements, dynamicShortCodeElements);
footerCopyrightText.generate();
